import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme)=> {
    return {
            container: {
                position: 'relative',
                display: 'grid',
                height: 'max-content',
                minHeight: '100%',
                maxHeight: '100%',
                gridTemplateRows: 'minmax(0, 1fr) auto',
                gridTemplateColumns: 'minmax(0px, 1fr)',
                gridTemplateAreas: '"chart" "footer"',
                rowGap: '1px',
                padding: 0,
                borderRadius: 1,
                border: 'none'
            },
            chart: {
                gridArea: "chart"
            },
            footer: {
                gridArea: "footer"
            },
            blur: {
                filter: `blur(12px) ${theme.palette.mode === 'dark' ? 'brightness(0.7)' : ''}`
            }
        }
})